import { type MouseEvent } from 'react';

import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { type Order, type RosterTableColumns } from './types';

const HeadCell = styled(TableCell)`
    font-weight: bold;
`;

interface HeadCellData {
    id: RosterTableColumns;
    label: string;
}

export interface RosterTableHeadProps {
    order: Order;
    orderBy: string;
    onRequestSort: (event: MouseEvent<unknown>, property: RosterTableColumns) => void;
    hasStudentGroups: boolean;
}

const RosterTableHead: React.FC<RosterTableHeadProps> = ({ order, orderBy, hasStudentGroups, onRequestSort }) => {
    const { t } = useTranslation('roster');
    const headCells: HeadCellData[] = [
        { id: 'user_name', label: t('name') },
        { id: 'email', label: t('Email') },
        { id: 'role', label: t('role') }
    ];
    if (hasStudentGroups) {
        headCells.push({ id: 'student_group_names', label: t('group-names') });
    }
    const createSortHandler = (property: RosterTableColumns) => (event: MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell, index) => (
                    <HeadCell
                        key={index}
                        align={'left'}
                        sortDirection={orderBy === headCell.id ? order : false }
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction = {orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </HeadCell>
                ))}
                <HeadCell
                    align={'center'}
                >
                    {t('actions')}
                </HeadCell>
            </TableRow>
        </TableHead>
    );
};

export default RosterTableHead;
